import axios from "axios";

// -----------START for chat conversations-----------
export const indexControldocAiChatConversations = (callback) => {
  var promise = axios({
    method: 'get',
    url: Routes.controldoc_ai_chat_conversations_path({'format': 'json'}),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error?.response);
    });;
};

export const createControldocAiChatConversation = (callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.controldoc_ai_chat_conversations_path({'format': 'json'}),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};
// -----------END for chat conversations-----------


// -----------START for chat messages-----------
export const indexControldocAiChatMessages = (chatConversationId, page = 1, callback) => {
  var promise = axios({
    method: 'get',
    url: Routes.controldoc_ai_chat_conversation_chat_messages_path({'format': 'json', 'chat_conversation_id': chatConversationId, 'page': page}),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error?.response);
    });;
};

export const createControldocAiChatMessage = (formData, chatConversation, callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.controldoc_ai_chat_conversation_chat_messages_path({'chat_conversation_id': chatConversation?.id, 'format': 'json'}),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
      'Content-Type': 'multipart/form-data'
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });;
};
// -----------END for chat messages-----------
